// Shared helpers for free column ordering (native + custom interleaved).
// A column's stable key is "n_<nativeKey>" or "f_<fieldId>".

export function colKeyForNative(col) {
	return "n_" + col.key;
}
export function colKeyForField(field) {
	return "f_" + field.id;
}

/**
 * Build the ordered list of column descriptors from the native columns + custom
 * fields and a saved order array of colKeys. Columns present in `orderArr` come
 * first (in that order); anything not listed (e.g. a newly added field) is
 * appended in its natural order. Stale keys in orderArr are ignored.
 *
 * Returns [{ kind: "native"|"custom", colKey, col?, field? }]
 */
export function buildOrderedColumns(nativeColumns, fields, orderArr) {
	const all = [];
	(nativeColumns || []).forEach(c => all.push({ kind: "native", colKey: colKeyForNative(c), col: c }));
	(fields || []).forEach(f => all.push({ kind: "custom", colKey: colKeyForField(f), field: f }));

	const byKey = {};
	all.forEach(d => (byKey[d.colKey] = d));

	const ordered = [];
	(orderArr || []).forEach(k => {
		if (byKey[k]) {
			ordered.push(byKey[k]);
			delete byKey[k];
		}
	});
	all.forEach(d => {
		if (byKey[d.colKey]) ordered.push(d);
	});
	return ordered;
}

/**
 * Return a new ordered-keys array with `dragKey` moved to just before
 * `targetKey`. If targetKey is missing, dragKey goes to the end.
 */
export function reorderKeys(orderedKeys, dragKey, targetKey) {
	const keys = (orderedKeys || []).filter(k => k !== dragKey);
	const idx = keys.indexOf(targetKey);
	if (idx === -1) keys.push(dragKey);
	else keys.splice(idx, 0, dragKey);
	return keys;
}
